<template>
    <router-link :tag="tag" :to="linkRoute" :title="linkTitle">
        <slot></slot>
    </router-link>
</template>

<script>

import navigationMixin from '@/core/mixins/navigationMixin.js'

export default {
    data: () => {
        return {
            linkRoute: {},
            linkTitle: ''
        }
    },
    mixins: [navigationMixin],
    watch: {
        navigationData(data) {
            this.updateLink(data)
        }
    },
    methods: {
        updateLink(data) {

            let linkRoute = {}
            if (this.route) {
                linkRoute = this.getRoute(this.route)
            } 

            let overwrite = false

            if (this.overlay !== false) {
                let currentOverlay = this.$route.query.overlay

                if (currentOverlay && currentOverlay === this.overlay) {
                    linkRoute.query = {overlay: this.overlay}
                    overwrite = this.getTitle(linkRoute)
                    linkRoute = this.currentRoute
                } else {
                    linkRoute.query = {overlay: this.overlay}
                }
            }

            if (this.paused) {
                if (linkRoute.query) {
                    linkRoute.query.paused = true
                } else {
                    linkRoute.query = {paused: true}
                }
            }

            this.linkTitle = overwrite || this.getTitle(linkRoute)

            this.linkRoute = linkRoute
        },
        getTitle(linkRoute) {
            let title = ""
            if (!this.title) {
                return this.getRouteTitle(linkRoute)
            }
            return this.title
        }
    }, 
    props: {
        tag: {
            type: String,
            required: false
        },
        route: {
            type: [Object, Boolean],
            default: false
        },
        overlay: {
            type: [String, Boolean]
        },
        paused: {
            type: Boolean,
            default: false
        },
        title: {
            type: [String, Boolean],
            default: false
        }
    },
    mounted() {
        this.updateLink(this.navigationData)
    }
}
</script>

<style lang="scss">
    
    @import '~@/core/assets/scss/_variables.scss';

</style>